import { useRef, useState } from "react";
import Title, { ConfirmPassword, EmailMobile, Message, OTP, SubmitClearButton } from "./LoginUtil";
import { encrypt, handleInput, handleReset } from "../Common/Util";
import { validateConfirmPassword, validateEmailMobile, validateOTP } from "./LoginValidate";
import { axiosErrorHandler, axiosPost, axiosResponseHandler } from "../Common/axios";

export function ResetPassword() {
  const [message, setMessage] = useState('');

  const [page, setPage] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const setMethod = { setEmail, setOtp, setPassword, setConfirmpassword, setMessage };
  const setResetMethod1 = { setEmail, setMessage };
  const setResetMethod2 = { setOtp, setPassword, setConfirmpassword, setMessage };

  const emailReference = useRef();
  const otpReference = useRef();
  const passwordReference = useRef();
  const confirmpasswordReference = useRef();

  const handleSubmit1 =  (event) => {
    var msg = '';
    if(msg==='') msg = validateEmailMobile(event,emailReference,email);
    setMessage(msg); 

    if(msg==='') {
      const data = {
        emailOrMobile: email,
      }
      axiosPost("/astrologer/resetpassword/otp", data,
        (response)=>{
          console.log('Error : '+response.data.code+' '+response.data.message);
          if(response.data.code==='100') {
            emailReference.current.focus();
            msg='Enter valid Email or Mobile number';
          } else if(response.data.code!=='200') {
            emailReference.current.focus();
            msg=response.data.message;
          } else {
            msg="<font color=\"blue\">OTP is sent to your email address.</font>";
            setPage('1');
          }
          setMessage(msg);
        },
        (error)=>{
          setMessage(axiosErrorHandler(emailReference,error));
        }
      );
    }
    event.preventDefault();
  }
  const handleSubmit =  (event) => {
    var msg = '';
    if(msg==='') msg = validateOTP(event, otpReference,otp);
    if(msg==='') msg = validateConfirmPassword(event, passwordReference,password,confirmpasswordReference,confirmpassword);
    setMessage(msg); 

    if(msg==='') {
      const data = {
        emailOrMobile: email,
        otp: ''+encrypt(otp),
        newPassword : ''+encrypt(password),
        confirmPassword : ''+encrypt(confirmpassword)
      }
      axiosPost("/astrologer/resetpassword", data,
        (response)=>{
          setMessage(axiosResponseHandler(response, otpReference, ()=>handleReset(setMethod,otpReference), "Password is reset successfully"));
        },
        (error)=>{
          setMessage(axiosErrorHandler(otpReference,error));
        }
      );
    }
    event.preventDefault();
  }

  return (
    <div class="container text-start">
      <Title title="Reset Password"/>
      <Message msg={message} />    
      { page===''? (
        <form method="post" onSubmit={handleSubmit1}>
          <EmailMobile reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)}/> 
          <SubmitClearButton callback={()=>handleReset(setResetMethod1,emailReference)}/> 
        </form>
      ) : (
        <form method="post" onSubmit={handleSubmit}>
          <OTP reference={otpReference} data={otp} callback={(event)=>handleInput(event,setMethod)}/> 
          <ConfirmPassword reference={passwordReference} confirmreference={confirmpasswordReference} value={password} confirmvalue={confirmpassword} callback={(event)=>handleInput(event,setMethod)} />
          <SubmitClearButton callback={()=>handleReset(setResetMethod2,otpReference)}/>
      </form>
      ) }
    </div> 
  );

}

